<template>
  <div class="content-home" ref="home" style="background: #f4f5f9">
    <home-swiper :bannerData="bannerData"></home-swiper>
    <div class="all-box">
      <home-notice
        :noticeCount="noticeCount"
        @goNoticeList="goNoticeList"
      ></home-notice>
      <home-state :personalInfo="personalObj"></home-state>
      <home-grid
        v-if="getUserIdMenuAPPAttr.length != 0"
        :menuList="getUserIdMenuAPPAttr"
      ></home-grid>
      <div v-show="nesrTypeOpen == false">
        <home-advisory
          :newsType="newsType"
          @goList="goList"
          :newTypeDetail="newTypeDetail"
          @getNewsId="ginNewsId"
        ></home-advisory>
      </div>
    </div>
  </div>
</template>
<script type="text/ecmascript-6">
import homeSwiper from "./components/swiper";
import homeNotice from "./components/notice";
import homeState from "./components/state2";
import homeGrid from "./components/gridIndex";
import interfaceAttr from "../../centralControl/utils/interfaceAttr";
import { mapMutations } from "vuex";
import homeAdvisory from "./components/advisory";
import { toast, getStaffDetails } from "@/common/api/api.js";
import { announcementVisibleList } from "@/common/api";
import moment from "moment";
export default {
  data() {
    return {
      personalObj: {}, //个人信息(包括积分和name)
      cachInfo: JSON.parse(localStorage.getItem("loginInfo")), //获取登录人员的信息
      // authorityInfoWx: "", //功能专区需要展示的数据
      getUserIdMenuAPPAttr: [], //功能专区需要展示的数据
      roleCode: "", //登录人角色
      newsType: [], //资讯分类列表
      newsTypeId: "", //接收从子组件传递过来的newTypeId
      newTypeDetail: [], //资讯详情数据
      nesrTypeOpen: false, //控制咨询type显示
      scrollTop: 0, //获取页面的滚动高度
      bannerData: [
        //轮播图数据
        {
          file_url: require("../../assets/images/banner_default.png")
        }
      ],
      newsTypeObj: {}, //资讯分类对象
      interAttrs:["getUserIdMenuAPP"], //需要请求的接口名称
      noticeCount: 0, //公告通知未读数量
    };
  },
  components: {
    homeSwiper,
    homeNotice,
    homeState,
    homeGrid,
    homeAdvisory
  },
  created() {},
  mounted() {
    this.init();
    window.addEventListener("scroll", this.handleScroll, true);
    this.$refs.home.scrollTop = this.scrollTop;
  },
  //页面离开的时候保存滚动高度
  deactivated() {
    sessionStorage.setItem("scrollTop", this.scrollTop);
  },
  // 每次进入页面时候重新设置滚动高度
  activated() {
    this.$refs.home.scrollTop = sessionStorage.getItem("scrollTop");
    document.title =
      (this.cachInfo.name && `${this.cachInfo.name}，欢迎您!`) || "";
    // 重新获取公告通知未读数量，确保从详情页返回时数据是最新的
    this.getNoticeCount();
  },
  beforeRouteLeave(to, from, next) {
    if (to.name === "login") {
      next({ name: "homeZhyf" });
    } else {
      next(); // 注意：这边next必须要写
    }
  },
  methods: {
    getUserIdMenuAPP(data){
      console.log(data.map(item => item.menu_name));

      this.getUserIdMenuAPPAttr =data;
    },
    // 获取页面滚动高度,重新赋值
    handleScroll() {
      this.scrollTop = this.$refs.home.scrollTop;
    },
    // 获取修改后的个人信息资料
    replayGetDate(id) {
      // 获取会员信息
      this.centralControl.axios.centralControl(
        "getStaffDetails",
        res => {
          const { code, data, message } = res;
          if (code == 200) {
            this.checkPhone(data);
            // console.log(data);
            localStorage.setItem("detailInfo", JSON.stringify(res.data));
          } else {
            toast(this, message, "error");
          }
        },
        {}
      );
    },
    // 检查有没有绑定手机号
    checkPhone(data) {
      data.phone == "未知" && toast(this, "请绑定手机号!");
    },
    // 去更多数据资讯列表
    goList() {
      this.$router.push({
        path: "/consultList",
        query: {
          welfareTypeId: this.newsTypeId,
          newsTypeName: this.newsTypeObj[this.newsTypeId]
        }
      });
    },
    // 把后端传来的数据进行转换
    eachangeName(attr) {
      for (let item of attr) {
        item.createTime = moment(item.createTime).format("YYYY-MM-DD"); // 把开始时间格式化
      }
    },
    // 获取微信权限积分list
    gianWxList() {
      let that = this;
      this.centralControl.axios.centralControl(
        "getUserMenuAPP",
        res => {
          const { code, data, message } = res;
          if (code == 200) {
            this.authorityInfoWx = data;
          } else {
            toast(this, message, "error");
          }
        },
        { roleCode: that.cachInfo.roleCode }
      );
    },
    // 获取轮播图
    gianBaner() {
      let that = this;
      this.centralControl.axios.centralControl(
        "getNewsCarouselAPP",
        res => {
          const { code, data, message } = res;
          if (code == 200) {
            if (data.length != 0) {
              this.bannerData = data;
            }
            // console.log(data);
          } else {
            toast(this, message, "error");
          }
        },
        {}
      );
    },
    // 获取资讯分类列表
    gianNewListType() {
      let that = this;
      this.centralControl.axios.centralControl(
        "getNewsTypeAPP",
        res => {
          const { code, data, message } = res;
          if (code == 200) {
            if (data.length != 0) {
              this.newsTypeId = data[0].id;
              // 咨询分类对象（传给资讯列表资讯分类名称）
              let newsTypeObj = {};
              data &&
                data.length &&
                data.forEach(item => {
                  newsTypeObj[item.id] = item.name;
                });
              this.newsTypeObj = newsTypeObj;

              this.gianNewListDetail(); //获取资讯分类详情数据
              this.newsType = data;
            } else {
              this.nesrTypeOpen = true;
            }
            // console.log(data);
          } else {
            toast(this, message, "error");
          }
        },
        {}
      );
    },

    // 获取资讯分类详情数据
    gianNewListDetail() {
      let that = this;
      this.centralControl.axios.centralControl(
        "getNewsListAPP",
        res => {
          const { code, data, message } = res;
          if (code == 200) {
            this.newTypeDetail = data;
            if (this.newTypeDetail.length != 0) {
              this.eachangeName(this.newTypeDetail);
            }
            // console.log(this.newTypeDetail);
          } else {
            toast(this, message, "error");
          }
        },
        {
          unionId: that.cachInfo.unionId,
          deptId: that.cachInfo.deptId,
          newsTypeId: that.newsTypeId
        }
      );
    },
    //获取从子组件传递过来的newsid
    ginNewsId(id) {
      this.newsTypeId = id;
      this.gianNewListDetail();
    },
    // 跳转到公告通知列表
    goNoticeList() {
      this.$router.push({
        path: "/noticeList"
      });
    },
    // 获取公告通知未读数量
    getNoticeCount() {
      announcementVisibleList({}).then((res) => {
        if (res.code == 200) {
          this.noticeCount = res.data.unreadCount;
        }
      });
    },
    // 获取个人积分，名称
    getIntegral() {
      this.centralControl.axios.centralControl(
        "integralAll",
        res => {
          if (res.code == 200) {
            this.personalObj = res.data;
            // this.$store.commit
            if (!res.data.photo) {
              this.personalObj.photo =
                res.data.sex === "2"
                  ? require("../../assets/images/doctor.png")
                  : require("../../assets/images/male_img.png");
            }
            let userInfo = JSON.parse(localStorage.getItem("loginInfo"));
            if (!userInfo.photo) {
              userInfo.photo =
                userInfo.sex === "2"
                  ? require("../../assets/images/doctor.png")
                  : require("../../assets/images/male_img.png");
            }
            // 修改vuex里面的integralAll
            // this.$store.commit("setIntegralAll",res.data.point);
            this.setIntegralAll(res.data.point);
            localStorage.setItem("point", res.data.point);
          } else {
            toast(this, res.message, "error");
          }
        },
        {}
      );
    },
    // 映射总积分到vuex
    ...mapMutations(["setIntegralAll"]),
    // 映射总步数到vuex
    ...mapMutations(["setStepAll"]),
    // 获取步数
    getStep() {
      moment;
      let time = moment(this.centralControl.utils.obtainEast8Date()).format(
        "YYYY-MM-DD"
      );
      this.centralControl.axios.centralControl(
        "stepAll",
        res => {
          if (res.code == 200) {
            res.data.stepCount = res.data.stepCount || "0";
            this.$set(this.personalObj, "stepAll", res.data.stepCount); //set方法解决数据变了，dom没有发生改变
            this.setStepAll(res.data.stepCount);
            localStorage.setItem("stepAll", res.data.stepCount);
            // console.log(this.personalObj);
          } else {
            this.$message.error(res.message);
          }
        },
        { stepDay: time }
      );
    },
    init() {
      this.cachInfo.id && this.replayGetDate(this.cachInfo.id); //获取pc修改过后的个人信息
      this.getIntegral(); //获取个人积分，名称
      this.getStep(); //获取今日总步数
      // this.gianWxList(); //获取功能专区
      this.gianBaner(); //获取轮播图
      this.gianNewListType(); //获取资讯分类列表
      this.getNoticeCount(); //获取公告通知未读数量
      this.centralControl.utils.eachIndexattr(this,this.interAttrs,interfaceAttr);
    }
  }
};
</script>
<style lang="stylus" type="stylesheet/stylus" scoped>
@import '../../assets/stylus/index.styl';

.content-home {
  position: absolute;
  top: 0;
  width: 100%;
  bottom: 0;
  overflow: scroll;
}

.all-box {
  position: relative;
  // background: #fff;
}
</style>
